/**
 * Created by calhosh on 4/14/2017.
 */

import * as english from './en-us';
import * as japanese from './ja-jp';
import * as frenchCanadian from './fr-ca';
import * as spanish from './es';
import * as portuguese from './pt-br';
import * as chineseSimplified from './zh-sp';
import * as chineseTraditional from './zh-tr';
import * as hebrew from './he';
import * as korean from './ko';
import * as russian from './ru';
import * as arabic from './ar';

const languages = {
	'en-us': english,
	'ja-jp': japanese,
	'fr-ca': frenchCanadian,
	es: spanish,
	'pt-br': portuguese,
	'zh-sp': chineseSimplified,
	'zh-tr': chineseTraditional,
	he: hebrew,
	ko: korean,
	ru: russian,
	ar: arabic,
	'es-mx': spanish
};

export default function(locale) {
	return Object.assign({}, languages['en-us'], languages[locale]);
}
